import React from "react";

import {ServiceModelImportingActions}
	from "controls/designer/features/serviceModelImport";
import {WidgetsActions} from "controls/designer/features/widgets/widgetsActions";
import {DesignerActions} from "controls/designer/shared";


const i = require('core/localization/localization').translator({
  "Service model": {
    "no": "Tjenestemodell",
    "en": "Servicemodel"
  },
  "Window": {
    "no": "Vindu"
  }
});


export default class PresentationDesignerExtension {
	model = null;

	attach(designer) {
		const ui = designer.ui;
		this.ui = ui
		this.editor = this.ui.editor;
		this.graph = this.editor.graph;
	}

	editorLoaded(){
		this.setupRightClickMenu();
		this.setupPasteAtCenter();
		this.setupWidgetDragHandle();
		const propertiesMenuItem = document.querySelector('.geToolbar .geButton .cogwheel')?.parentNode;
		propertiesMenuItem?.parentNode.appendChild(propertiesMenuItem);
	}

	setModel(model) {
		this.model = model;
	}

	setupRightClickMenu() {
		var original = this.ui.menus.createPopupMenu;
		this.ui.menus.createPopupMenu = function (menu, cell, evt) {
			menu.smartSeparators = true;
			const graph = this.editorUi.editor.graph;
			const designer = graph.designer

			const selectedCell = graph.getSelectionCell();


			if (selectedCell == null){
				this.addMenuItems(menu, ['undo', '-', 'pasteHere']);
				this.addMenuItems(menu, ['-' + i('Select'), DesignerActions.SelectConnectors,
					DesignerActions.SelectShapes, DesignerActions.SelectAll]);
				this.addMenuItems(menu, ['-' + i('Add'), DesignerActions.InsertImage,
					ServiceModelImportingActions.ShowImportDialog]);
				this.addMenuItems(menu, ['-'])
				this.addMenuItems(menu, ['-' + i('Window'), "outline", "formatPanelShow", 'formatPanel', 'shapes-collection']);
			}else{
				this.addMenuItems(menu, ['undo','-', 'delete', 'cut', 'copy']);

				if(graph.getSelectionCount() == 1) {
					this.addMenuItems(menu,
						designer.store.widgetsManager.get(selectedCell) != null
							? [WidgetsActions.ShowEditWidgetFormForSelectedCell]
							: ['edit']);
				}

				this.addMenuItems(menu, ['-', 'toFront', 'toBack']);

				if (graph.getSelectionCount() == 1 &&!graph.getModel().isEdge(cell) && !graph.isSwimlane(cell) &&
					graph.getModel().getChildCount(cell) > 0) {
					this.addMenuItems(menu, ['-', 'ungroup'], null, evt);
				}

				if (graph.getSelectionCount() > 1) {
					 this.addMenuItems(menu, ['-', 'group'], null, evt);
				}

				if(!designer.store.widgetsManager.get(selectedCell))
				{
					this.addMenuItems(menu, ["user-shapes-add"], null, evt);
				}

				this.addMenuItems(menu, ['-', 'formatPanelShow'], null, evt);
			}
		}
	}

	setupPasteAtCenter() {
		const graph = this.graph;
		const pasteAction = this.ui.actions.get('paste');

		pasteAction.funct = function () {
			if (graph.isEnabled() && !graph.isCellLocked(graph.getDefaultParent())) {
				graph.getModel().beginUpdate();
				try {
					var cells = mxClipboard.paste(graph);

					if (cells != null) {
						var bb = graph.getBoundingBoxFromGeometry(cells);

						if (bb != null) {
							var t = graph.view.translate;
							var s = graph.view.scale;
							var container = graph.container;

							var triggerX = container.scrollLeft + container.clientWidth / 2;
							var triggerY = container.scrollTop + container.clientHeight / 2;

							var cx = graph.snap(triggerX / s - t.x);
							var cy = graph.snap(triggerY / s - t.y);

							graph.cellsMoved(cells, cx - bb.getCenterX(), cy - bb.getCenterY());
						}
					}
				}
				finally {
					graph.getModel().endUpdate();
				}
			}
		};
	}

	// Reuses mxGraph's own "presentation mode" drag handle (see shapes.js
	// mxVertexHandler.prototype.createCustomHandles) instead of a hand-rolled overlay: it's a
	// native mxHandle already wired up (graph.js mxVertexHandler.prototype.mouseDown) to be read
	// as a move, never a resize, regardless of where it sits on the shape. Normally it only
	// appears for cells explicitly flagged with a "showDragHandle" attribute; here it's added for
	// any single-selected, movable dashboard widget instead.
	setupWidgetDragHandle() {
		if (mxVertexHandler.prototype.ceeviewWidgetDragHandlePatched) {
			return;
		}
		mxVertexHandler.prototype.ceeviewWidgetDragHandlePatched = true;

		const originalCreateCustomHandles = mxVertexHandler.prototype.createCustomHandles;

		mxVertexHandler.prototype.createCustomHandles = function () {
			const handles = originalCreateCustomHandles.apply(this, arguments);
			const cellGraph = this.graph;
			const widgetsManager = cellGraph.designer?.store?.widgetsManager;

			if (this.state.view.graph.getSelectionCount() == 1
				&& widgetsManager?.get(this.state.cell) != null
				&& cellGraph.isCellMovable(this.state.cell)
				&& !handles.some((h) => h.dragHandle)) {

				const dragHandle = new mxHandle(this.state, 'move', HoverIcons.prototype.dragSource);
				dragHandle.dragHandle = true;

				dragHandle.getPosition = function (bounds) {
					return new mxPoint(bounds.x + bounds.width + 20, bounds.y - 20);
				};

				handles.push(dragHandle);
			}

			return handles;
		};
	}

	destroy(){
		this.selectServiceWindow?.destroy();
	}
}
